import "./newAgency.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import { useEffect, useState } from "react";
import {
  addDoc,
  collection,
  doc,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import Toggle from "react-toggle";
import "react-toggle/style.css";

import { auth, db, storage } from "../../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { agencyInputs as inputs } from "../../newAgencyFormSource";

const NewAgency = () => {
  const [file, setFile] = useState("");
  const [data, setData] = useState({});
  const [per, setPerc] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const uploadFile = () => {
      const name = new Date().getTime() + file.name;

      console.log(name);
      const storageRef = ref(storage, file.name);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          setPerc(progress);
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
            default:
              break;
          }
        },
        (error) => {
          console.log(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            setData((prev) => ({ ...prev, logo: downloadURL }));
          });
        }
      );
    };
    file && uploadFile();
  }, [file]);

  const handleInput = (e) => {
    let id = e.target.id;
    let value = e.target.value;

    if (id === "startDate" || id === "endDate") {
      setData({ ...data, [id]: new Date(value) });
      return;
    }
    if (
      e.target.name === "callin" ||
      e.target.name === "dutycrews" ||
      e.target.name === "library" ||
      e.target.name === "rigchecks" ||
      e.target.name === "stationboards"
    ) {
      id = e.target.name;
      value = e.target.checked;
    }

    setData({ ...data, [id]: value });
  };

  const setAgencyCollections = async (data) => {
    console.log(data);
    // Set sub collections
    await setDoc(doc(db, "Agencies", data.name), {});
    await addDoc(collection(db, "Agencies", data.name, "Alarms"), {});
    await addDoc(collection(db, "Agencies", data.name, "Groups"), {});
    await addDoc(collection(db, "Agencies", data.name, "Library"), {});
    await addDoc(collection(db, "Agencies", data.name, "Rigchecks"), {});
    await setDoc(doc(db, "Agencies", data.name, "Settings", "Services"), {
      Callin: data.callin || false,
      Dutycrews: data.dutycrews || false,
      Library: data.library || false,
      Rigchecks: data.rigchecks || false,
      Stationboards: data.stationboards || false,
    });
    await setDoc(doc(db, "Agencies", data.name, "Settings", "Info"), {
      address: data.address,
      logo: data.logo || "",
    });
    await addDoc(collection(db, "Agencies", data.name, "Scanner"), {});
    await addDoc(collection(db, "Agencies", data.name, "Station Board"), {
      apiKey: "",
      description: "",
      endPoint: "",
      logoURL: data.logo || "",
      name: data.name,
      tokens: [],
      when2work: false,
      when2workapp: false,
      zip: "",
    });
    await setDoc(doc(db, "AgencyCodes", data.name), {
      Active: true,
    });

    // Set main collections
    await addDoc(collection(db, data.name), {});
    await addDoc(collection(db, data.name + " Alarms"), {});
    await addDoc(collection(db, data.name + " Groups"), {});
    await addDoc(collection(db, data.name + " Library"), {});
    await addDoc(collection(db, data.name + " Rigchecks"), {});
    await setDoc(doc(db, data.name + " Settings", "Services"), {
      Callin: data.callin || false,
      Dutycrews: data.dutycrews || false,
      Library: data.library || false,
      Rigchecks: data.rigchecks || false,
      Stationboards: data.stationboards || false,
    });
    await setDoc(doc(db, data.name + " Settings", "Info"), {
      address: data.address,
      logo: data.logo || "",
    });
    await addDoc(collection(db, data.name + " Scanner"), {});
    await addDoc(collection(db, data.name + " Station Board"), {
      apiKey: "",
      description: "",
      endPoint: "",
      logoURL: data.logo || "",
      name: data.name,
      tokens: [],
      when2work: false,
      when2workapp: false,
      zip: "",
    });
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    data.status = "ACTIVE";
    data.comments = "";

    if (!data.startDate || !data.endDate || !data.paymentduedate) return;

    data.name = data.name.trimEnd();

    try {
      await setDoc(doc(db, "CRM", data.name), {
        ...data,
      });

      await setAgencyCollections(data);
      navigate(-1);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>New Agency</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <img
              src={
                file
                  ? URL.createObjectURL(file)
                  : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
              }
              alt=""
            />
          </div>
          <div className="right">
            <form onSubmit={handleAdd}>
              <div className="formInput">
                <label htmlFor="file">
                  Logo: <DriveFolderUploadOutlinedIcon className="icon" />
                </label>
                <input
                  type="file"
                  id="file"
                  onChange={(e) => setFile(e.target.files[0])}
                  style={{ display: "none" }}
                />
              </div>

              {inputs.map((input) => (
                <div className="formInput" key={input.id}>
                  <label>{input.label}</label>
                  <input
                    id={input.id}
                    type={input.type}
                    placeholder={input.placeholder}
                    onChange={handleInput}
                  />
                </div>
              ))}
              <button disabled={per !== null && per < 100} type="submit">
                Submit
              </button>
            </form>
            <div id="settings">
              <h3>Services:</h3>
              <label className="toggle">
                Call In
                <Toggle icons={false} name="callin" onChange={handleInput} />
              </label>
              <label className="toggle">
                Duty Crews
                <Toggle icons={false} name="dutycrews" onChange={handleInput} />
              </label>
              <label className="toggle">
                Libary
                <Toggle icons={false} name="library" onChange={handleInput} />
              </label>
              <label className="toggle">
                Rigchecks
                <Toggle icons={false} name="rigchecks" onChange={handleInput} />
              </label>
              <label className="toggle">
                Station Boards
                <Toggle
                  icons={false}
                  name="stationboards"
                  onChange={handleInput}
                />
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewAgency;
